<div mat-dialog-title>
  <mode-dialog-header>
    <h1 heading>Some emails failed to send</h1>
  </mode-dialog-header>
</div>
<div mat-dialog-content>
  <p class="message">
    The Report could not be shared with some of the email addresses you entered.
    Check the emails listed below to ensure they are valid, and try again.
  </p>
  <ul class="entries">
    <li *ngFor="let failure of data.failures"
      data-test="entry"
      class="entry"
    >
      <capra-icon icon="icon-close">
      </capra-icon>
      {{ failure }}
    </li>
  </ul>
</div>
<div mat-dialog-actions>
  <capra-button
    text="Okay"
    (clicked)="dialogRef.close()"
  ></capra-button>
</div>
